import { writable } from 'svelte/store';
import { PermissionsList } from '@/types/user';
import { AssetService, UserService } from '@/services';
import { loadUserImageUrl } from '@/utils/common';
import collect from 'collect.js';
import { GoogleStorage } from '../../services/google/google.service';
import { ASSET_CATEGORY } from '../../services/asset';
import '@/types/common';
const userService = new UserService();
const initialUserState = {
    brandKit: null,
    membership: '',
    permissions: [],
    subscription: {
        subscriptionId: '',
        status: '',
        sermonliveSubscriptionId: '',
        customerId: ''
    },
    hasFullAccess: true,
    isAdmin: false,
    credits: 0,
    isImpersonated: false,
    details: null,
    preferences: {
        language: 'english',
        resync: false,
        favorites: {
            fonts: []
        }
    }
};
const { subscribe, update } = writable(initialUserState);
let userState;
subscribe(user => (userState = user));
async function getImageWidth(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = event => {
            const img = new Image();
            img.onload = () => {
                console.log('Image loaded successfully');
                resolve(img.naturalWidth);
            };
            img.onerror = error => {
                console.error('Error loading image', error);
                reject(new Error('Error loading image'));
            };
            if (event?.target?.result)
                img.src = event?.target?.result;
        };
        reader.onerror = error => {
            console.error('Error reading file', error);
            reject(new Error('Error reading file'));
        };
        reader.readAsDataURL(file);
    });
}
const actions = {
    set: (updatedState) => {
        update(store => ({ ...store, ...updatedState }));
    },
    getUser: async (isAdmin = false, isImpersonated = false) => {
        const response = await userService.getUser();
        if (response && response.length != 0) {
            let membership = response.membership.title;
            let hasFullAccess = response.hasFullAccess;
            let permissions = response.permissions;
            let credits = response.usage;
            let details = response.user;
            let preferences = response.user.preferences;
            let subscription = response.subscription;
            update(user => {
                return {
                    ...user,
                    details,
                    hasFullAccess: hasFullAccess,
                    membership: membership,
                    permissions: permissions,
                    credits: credits,
                    isAdmin: isAdmin,
                    isImpersonated: isImpersonated,
                    preferences: preferences,
                    subscription: subscription
                };
            });
        }
        return response;
    },
    getBrandKit: async () => {
        const response = await userService.getBrandKitFromApi();
        update(user => {
            return {
                ...user,
                brandKit: {
                    rawJSON: response,
                    logoUrl: response.logo
                        ? response.logo.includes('http')
                            ? response.logo
                            : loadUserImageUrl('brandKit/' + response.logo)
                        : '',
                    serviceTimes: response.serviceTimes || ''
                }
            };
        });
    },
    /**
     * DEPRECATED OLD METHOD OF GETTING THE USERS BRAND KIT
     */
    _getBrandKit: async () => {
        const response = await userService.getBrandKit();
        if (response && response.brand_kit) {
            const parsed = JSON.parse(response.brand_kit);
            update(user => {
                return {
                    ...user,
                    brandKit: {
                        rawJSON: parsed,
                        logoUrl: parsed.logo ? loadUserImageUrl('brandKit/' + parsed.logo) : '',
                        serviceTimes: parsed.serviceTimes || ''
                    }
                };
            });
        }
    },
    setMembershipData: async (membership) => {
        let permissions = collect(PermissionsList).firstWhere('name', membership);
        update(user => {
            return {
                ...user,
                membership: membership,
                permissions: permissions.values
            };
        });
    },
    updateLogo: async (file) => {
        const assetService = new AssetService();
        // validateThatFileIsImage(file);
        const imageWidth = await getImageWidth(file);
        if (imageWidth > 1024) {
            alert('Image width is too large. Maximum width is 1024px');
            return;
        }
        const filename = file?.name;
        const generatedFilename = 'images/' + filename;
        const url = await assetService.generateNames([generatedFilename]);
        const data = url.data;
        await GoogleStorage.uploadFileFromSignedUrl(data[0], file, {
            onProgress: progress => {
                console.log('Progress', progress);
            },
            onComplete: () => { }
        });
        const resp = await assetService.saveUploadedAsset([generatedFilename], ASSET_CATEGORY.IMAGE);
        const brandkit = await userService.getBrandKitFromApi();
        console.log('brandkit', brandkit);
        if (!window.brandKit) {
            window.brandKit = brandkit;
        }
        window.brandKit.logo = resp.data.file.publicUrl;
        await userService.updateBrandkit(false);
    },
    updatePreferences: async (payload) => {
        const response = await userService.updatePreferences(payload);
        update(user => {
            return {
                ...user,
                preferences: response.preferences
            };
        });
    }
    // updateLogo: async (file: any) => {
    // 	const { brandKit } = userState;
    // 	if (brandKit?.logoUrl) {
    // 		userService.deleteCurrentLogo(brandKit.rawJSON.longo);
    // 	}
    // 	const fileName = await userService.uploadBrandLogo(file, true);
    // 	const bk = brandKit
    // 	? { ...brandKit?.rawJSON, logo: fileName }
    // 	: { logo: fileName };
    // 	await userService.saveBrandKit(bk);
    // },
};
const user = {
    subscribe,
    ...actions
};
export default user;
